import CloseIcon from '@mui/icons-material/Close'
import { Box, Divider, IconButton, Stack } from '@mui/material'
import moment from 'moment'
import 'moment/locale/ru'
import { FC, useMemo } from 'react'
import { TypographyPrimary } from 'ui/typography/TypographyPrimary'
import type { ShiftCellAssignment } from './ShiftScheduleGrid'
import { groupAssignmentsByParlor } from './shiftEmployeeDrawerUtils'

moment.locale('ru')

export const SHIFT_DRAWER_STAT_LABEL_WIDTH = '148px'
export const SHIFT_DRAWER_PARLOR_MARGIN_BOTTOM = '14px'

interface ShiftListItemProps {
	assignment: ShiftCellAssignment
	showDelete?: boolean
	onDelete?: (assignment: ShiftCellAssignment) => void
}

export const ShiftDrawerShiftListItem: FC<ShiftListItemProps> = ({
	assignment,
	showDelete = false,
	onDelete,
}) => (
	<Stack
		direction='row'
		alignItems='flex-start'
		justifyContent='space-between'
		sx={{ width: '100%' }}
	>
		<Stack
			direction='row'
			alignItems='flex-start'
			sx={{ flex: 1, minWidth: 0 }}
		>
			<Box sx={{ width: SHIFT_DRAWER_STAT_LABEL_WIDTH, flexShrink: 0 }}>
				<TypographyPrimary sx={{ color: '#8D8D96', fontSize: '16px' }}>
					{moment(assignment.date).format('dd DD.MM').toUpperCase()}
				</TypographyPrimary>
			</Box>
			<Stack direction='column' gap='6px' sx={{ minWidth: 0, flex: 1 }}>
				<TypographyPrimary sx={{ fontSize: '16px' }}>
					{`${assignment.title}, ${assignment.timeRange}`}
				</TypographyPrimary>
				<TypographyPrimary sx={{ color: '#8D8D96', fontSize: '16px' }}>
					{`Место ${assignment.zones?.join(', ') ?? '-'}`}
				</TypographyPrimary>
			</Stack>
		</Stack>
		{showDelete && (
			<IconButton
				size='small'
				sx={{ p: 0, flexShrink: 0, ml: '8px' }}
				onClick={() => onDelete?.(assignment)}
			>
				<CloseIcon sx={{ color: '#7F7F84', fontSize: '20px' }} />
			</IconButton>
		)}
	</Stack>
)

interface ShiftDrawerShiftListProps {
	assignments: ShiftCellAssignment[]
	showDelete?: boolean
	onDelete?: (assignment: ShiftCellAssignment) => void
}

export const ShiftDrawerShiftList: FC<ShiftDrawerShiftListProps> = ({
	assignments,
	showDelete = false,
	onDelete,
}) => {
	const groups = useMemo(
		() => groupAssignmentsByParlor(assignments),
		[assignments],
	)

	return (
		<Stack direction='column'>
			{groups.map(([parlorName, items], index) => (
				<Box key={parlorName}>
					{index > 0 && <Divider sx={{ borderColor: '#DBDBDB', my: '14px' }} />}
					<TypographyPrimary
						sx={{
							fontSize: '16px',
							mb: SHIFT_DRAWER_PARLOR_MARGIN_BOTTOM,
						}}
					>
						{parlorName}
					</TypographyPrimary>
					<Stack direction='column' gap='12px'>
						{items.map(item => (
							<ShiftDrawerShiftListItem
								key={item.id}
								assignment={item}
								showDelete={showDelete}
								onDelete={onDelete}
							/>
						))}
					</Stack>
				</Box>
			))}
		</Stack>
	)
}
